<template>
    <div>
        <support-button 
            v-on:openSupportReveal="openQuoteReveal">
        </support-button>
        <quote-reveal 
            v-if="toggle_quote_reveal"
            v-on:closeQuoteReveal="closeQuoteReveal">
        </quote-reveal>
    </div>
</template>
<script>
    import SupportButton        from '../../components/support/support-button.vue';
    import QuoteReveal          from '../../global/quote-reveal';

    export default {
        name: 'support',
        props: [],
        data() {
            return {
                toggle_quote_reveal: false
            }
        },
        components: {
            'support-button'    : SupportButton,
            'quote-reveal'      : QuoteReveal
        },
        mounted() {
            // Get the url search parameters
            let url_params = new URLSearchParams(window.location.search);

            // Get the open search parameter
            let open_param = url_params.get('open');

            // Only trigger a click when value of the open search parameter is 'offerteformulier'
            if( open_param == 'offerteformulier' ) {
                this.openQuoteReveal();
            }
        },
        methods: {
            /**
             * Request the quote reveal
             *
             * @author Dennis Bruinen <dennis@click.nl>
             * @return void
             */
            openQuoteReveal() {
                this.toggle_quote_reveal = true;
            },
            /**
             * Close the quote reveal
             *
             * @author Dennis Bruinen <dennis@click.nl>
             * @return void
             */
            closeQuoteReveal() {
                this.toggle_quote_reveal = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/support/support.vue